import 'emoji-mart/css/emoji-mart.css';

import type { Reaction } from '@assembly-web/services';
import { ReactionTypes } from '@assembly-web/services';
import type { EmojiData } from 'emoji-mart';
import { Picker } from 'emoji-mart';
import { useCallback, useState } from 'react';
import { defineMessages, useIntl } from 'react-intl';

import { ReactIcon } from '../../assets/icons';
import { Popover } from '../Popover';

const messages = defineMessages({
  reactLabel: {
    defaultMessage: 'React',
    id: 'uX6eKe',
  },
});

export function ReactionPicker({
  onReactionClick,
}: {
  onReactionClick: (reaction: Reaction) => void;
}) {
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);

  const { formatMessage } = useIntl();

  const toggleEmojiPicker = () => {
    setShowEmojiPicker(!showEmojiPicker);
  };

  const onEmojiSelect = useCallback(
    (emoji: EmojiData) => {
      onReactionClick({
        name: emoji.colons ?? '',
        value: emoji.id ?? '',
        type: ReactionTypes.Regular,
        displayName: emoji.id ?? '',
      });
      setShowEmojiPicker(false);
    },
    [onReactionClick]
  );

  return (
    <div>
      <Popover
        onTriggerButtonClick={toggleEmojiPicker}
        trigger={
          <div className="flex w-fit items-center rounded-2xl bg-gray-3 px-3 text-gray-8 hover:bg-gray-4">
            <ReactIcon className="h-6 w-auto pr-1 text-gray-8" />
            <span className="py-1 text-sm">
              {formatMessage(messages.reactLabel)}
            </span>
          </div>
        }
        open={showEmojiPicker}
        onOpenChange={setShowEmojiPicker}
      >
        <Picker
          onClick={onEmojiSelect}
          native
          sheetSize={16}
          set="apple"
          title="Pick your emoji"
        />
      </Popover>
    </div>
  );
}
